/**
 * HTML escaping.
 *
 * Every published page is assembled by string concatenation from text a
 * stranger typed, so this is the only thing standing between a tagline and
 * stored XSS on a domain that also serves the builder. Escape at the point of
 * interpolation, never at the point of storage -- storing pre-escaped text
 * means it double-escapes the moment it is rendered anywhere else.
 */

const HTML_ENTITIES: Readonly<Record<string, string>> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
}

/** Escape for use in element text or a double-quoted attribute. */
export function esc(value: string): string {
  return value.replace(/[&<>"']/g, (c) => HTML_ENTITIES[c] ?? c)
}

/**
 * Validate and escape a user-supplied URL.
 *
 * Returns undefined for anything that is not http(s) -- `javascript:` and
 * `data:` URLs in an href are script execution, and this is the only place a
 * founder can supply a link.
 */
export function safeUrl(value: string | undefined): string | undefined {
  if (!value) return undefined
  let parsed: URL
  try {
    parsed = new URL(value)
  } catch {
    return undefined
  }
  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return undefined
  return esc(parsed.toString())
}
